<script>
import ImageLoader from '@components/ImageLoader'
import Button from '@components/Button'

export default {
  name: 'AppBar',
  components: {
    ImageLoader,
    Button
  },
  props: {
    scale: {
      type: Number,
      default: 1
    }
  },
  computed: {
    styles () {
      return {
        appBar: {
          '--scale': this.scale
        },
        logo: {
          '--margin-left': this.rl.margin
        },
        btnLogin: {
          '--margin-right': this.rl.margin
        }
      }
    }
  },
  methods: {
    goToLogin () {
      window.location.href = this.wl.urls.login
    }
  }
}
</script>

<template>
  <div
    class="app-bar"
    :style="styles.appBar"
  >
    <ImageLoader
      :url="wl.images.WOLIFLIX_LOGO"
      class="logo"
      :style="styles.logo"
      @click="$router.push({name: 'Home'})"
    />
    <div class="btn-login-container">
      <p
        v-if="rl.smAndUp"
        class="btn-login-pergunta"
      >
        {{ wl.strings['pergunta-ja-e-assinante'] }}
      </p>
      <Button
        size="md"
        :color="wl.colors.secondary"
        :text-color="wl.colors.on.secondary"
        :text="wl.strings['btn-login']"
        :style="styles.btnLogin"
        outlined
        class="btn-login"
        :scale="scale"
        @click="() => goToLogin()"
      />
      <Button
        size="md"
        :color="wl.colors.secondary"
        :text-color="wl.colors.on.secondary"
        :text="wl.strings['btn-contato']"
        :style="styles.btnLogin"
        flat
        class="btn-contato"
        :scale="scale"
        @click="() => $router.push({name: 'Contato'})"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.app-bar {
  padding: calc(45px * var(--scale)) 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .logo {
    width: calc(276px * var(--scale));
    height: calc(60px * var(--scale));
    margin-left: var(--margin-left);
  }
  .btn-login-container {
    display: flex;
    align-items: center;
    .btn-login-pergunta {
      font-size: calc(16px * var(--scale));
      margin-right: calc(15px * var(--scale));
    }
    .btn-contato {
      margin-right: var(--margin-right);
    }
  }
}
</style>
